import React from "react";

import { Select, Button, Col, Row, Form } from "antd";
import { v4 as uuidv4 } from "uuid";
import { phoneType } from "../../../../../utils/Util";
const { Option } = Select;

function IncludedReports({ includedReports, setIncludedReports }) {
  const addIncludedReport = () => {
    const newIncludedReport = {
      id: uuidv4(),
      includedReport: "",
    };
    setIncludedReports([...includedReports, newIncludedReport]);
  };

  const removeIncludedReport = (id) => {
    const updatedIncludedReports = includedReports.filter(
      (item) => item.id !== id
    );
    setIncludedReports(updatedIncludedReports);
  };

  const handleChange = (value, name, id) => {
    const updatedincludedReports = includedReports.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setIncludedReports(updatedincludedReports);
  };

  return (
    <ul>
      {includedReports.map((item, index) => (
        <li key={item.id}>
          <Row style={{ marginBottom: 12 }}>
            <Col span={23}>
              <Form.Item
                label="includedReports"
                wrapperCol={{ span: 8 }}
                name={`includedReports${index}`}
              >
                <Select
                  onChange={(value) =>
                    handleChange(value, "includedReport", item.id)
                  }
                >
                  {phoneType.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={1}>
              {includedReports.length > 1 ? (
                <Button
                  className="roundSmallButton"
                  onClick={() => {
                    removeIncludedReport(item.id);
                  }}
                  type="primary"
                  shape="circle"
                  icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                  size={"small"}
                />
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </li>
      ))}

      <Button
        className="addPropertyGroupButton"
        type="primary"
        onClick={addIncludedReport}
        size={"small"}
        icon={<i className="fa-solid fa-circle-plus"></i>}
      >
        Add Another Phone Number
      </Button>
    </ul>
  );
}

export default IncludedReports;
